module.exports = __webpack_public_path__ + "img/add-products-dark.a53467a1.svg";